module.exports = __webpack_public_path__ + "static/hero-hcp-safety-large-76399fb7b7336b44811f63b22a3e2948.png";